export default __webpack_public_path__ + "static/media/Roboter-Katze-Fisch.1804e903.webp";